module.exports = __webpack_public_path__ + "static/2-d5e4c6d722d26a9d7688c19b20b60096.png";